module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00052-fs8.f0a666a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00052-fs8.png
// module id = 205
// module chunks = 0